import { render, staticRenderFns } from "./UiCardField.vue?vue&type=template&id=5d59e408&"
import script from "./UiCardField.vue?vue&type=script&lang=js&"
export * from "./UiCardField.vue?vue&type=script&lang=js&"
import style0 from "./UiCardField.vue?vue&type=style&index=0&id=5d59e408&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports